import { get, post } from '../paymentLinkHttp'

class AutoCollectAPI {
    static _csrfHeaders = () => ({ 'X-CSRFToken': AutoCollectAPI.getCookie('csrftoken'), 'Content-Type': 'application/json' })
    
    static get_mandate = (slug) => {
        let endpoint = `auto-collect/${slug}/`
        return get(endpoint);
    }

    static register_mandate = (slug) => {
        let endpoint = `auto-collect/${slug}/`;
        return post(endpoint, {}, AutoCollectAPI._csrfHeaders())
    }

    static getCookie(name) {
        const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return cookieValue ? cookieValue.pop() : '';
    }

    static get_response = (slug, transaction_id) => {
        let endpoint = `auto-collect/response/${slug}/${transaction_id}/`
        return get(endpoint);
    }


    static generate_otp = (slug, transaction_id) => {
        let endpoint = `auto-collect/response/${slug}/${transaction_id}/generate-otp/`;
        return post(endpoint, {}, AutoCollectAPI._csrfHeaders())
    }

    static resend_otp = (slug, transaction_id) => {
        let endpoint = `auto-collect/response/${slug}/${transaction_id}/resend-otp/`;
        return post(endpoint, {}, AutoCollectAPI._csrfHeaders())
    }

    static upload_mandate = (slug, transaction_id, queryData) => {
        let endpoint = `auto-collect/response/${slug}/${transaction_id}/upload-mandate/`;
        return post(endpoint, queryData, AutoCollectAPI._csrfHeaders())
    }

    static get_mandate_details = (queryData) => {
        let endpoint = "auto-collect/mandate/get/";
        return post(endpoint, queryData);
    }

}

export default AutoCollectAPI;